module.exports = __webpack_public_path__ + "img/logo.311e4bdf.svg";